import { useState } from 'react';
import { useNavigate } from '@tanstack/react-router';
import { useQuery } from '@tanstack/react-query';
import { useAccess } from './api/data';
import { api, getObject, mutationHeaders, type Schema } from './api/client';
import { apiError, clearSession, cookieValue } from './api/session';
import { Button, ErrorState, Field } from './ui';
import { Link } from '@tanstack/react-router';
import { SecurityFactors } from './security-pages';
export function AccountSettings() {
  const navigate = useNavigate();
  const onClose = () => void navigate({ to: '/' });
  const access = useAccess();
  const [pending, setPending] = useState(false);
  const [error, setError] = useState<Error | null>(null);
  const factors = useQuery({
    queryKey: ['mfa-status'],
    queryFn: ({ signal }) => getObject<Schema<'MfaStatusResponse'>>('/api/v1/auth/mfa', {}, signal),
  });
  return (
    <section className="form-page account-settings-page">
      <div className="form-page-heading">
        <h1>Безопасность</h1>
      </div>
      <form
        className="domain-form"
        onSubmit={async (event) => {
          event.preventDefault();
          setPending(true);
          setError(null);
          const values = new FormData(event.currentTarget);
          try {
            if (values.get('newPassword') !== values.get('confirmPassword'))
              throw new Error('Новые пароли не совпадают');
            const result = await api.POST('/api/v1/auth/change-password', {
              params: { header: mutationHeaders() },
              body: {
                currentPassword: String(values.get('currentPassword')),
                newPassword: String(values.get('newPassword')),
              },
            });
            if (result.error) throw apiError(result.response, result.error);
            clearSession();
            onClose();
          } catch (cause) {
            setError(cause as Error);
          } finally {
            setPending(false);
          }
        }}
      >
        <h3>Сменить пароль</h3>
        <Field
          label="Текущий пароль"
          name="currentPassword"
          type="password"
          autoComplete="current-password"
          minLength={12}
          required
        />
        <Field
          label="Новый пароль"
          name="newPassword"
          type="password"
          autoComplete="new-password"
          minLength={12}
          required
        />
        <Field
          label="Повторите новый пароль"
          name="confirmPassword"
          type="password"
          autoComplete="new-password"
          minLength={12}
          required
        />
        <p className="muted">После смены пароля потребуется войти повторно.</p>
        {error && <ErrorState error={error} />}
        <Button className="primary" type="submit" disabled={pending}>
          {pending ? 'Сохранение…' : 'Сменить пароль'}
        </Button>
        <section className="detail-section">
          <h3>Подтверждение входа</h3>
          {factors.error ? (
            <ErrorState error={factors.error} />
          ) : (
            <SecurityFactors factors={factors.data?.factors || []} />
          )}
        </section>
        <Link className="pill" to="/account/notifications">
          Настройки уведомлений
        </Link>
        <Button
          onClick={async () => {
            setPending(true);
            try {
              const result = await api.POST('/api/v1/auth/logout-all', {
                body: { version: access.data?.account.version || 1 },
                params: { header: mutationHeaders() },
                headers: { 'X-CSRF-Token': cookieValue('__Host-snaphire_csrf') || '' },
              });
              if (result.error) throw apiError(result.response, result.error);
              clearSession();
              onClose();
            } catch (cause) {
              setError(cause as Error);
            } finally {
              setPending(false);
            }
          }}
          disabled={pending}
        >
          Выйти на всех устройствах
        </Button>
      </form>
    </section>
  );
}
